import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.register(ArcElement, ChartDataLabels);

interface DonutChartProps {
  data: any;
  options: any;
}

const DonutChart: React.FC<DonutChartProps> = ({ data, options }) => {
  return <Doughnut data={data} options={options} />;
};

export default DonutChart;
